import { IDropdownItem, IDropdownListSearch } from "../../../types/dropdownInterface";
import { BranchDropdown, BranchDropdownActionType } from "../../actionTypes/master/branchDropdownActionTypes";

export const getBranchListDropdown = (payload: IDropdownListSearch): BranchDropdownActionType => ({
  type: BranchDropdown.GET_BRANCH_DROPDOWN_LIST,
  payload,
});

export const setBranchListDropdown = (payload: Array<IDropdownItem>): BranchDropdownActionType => ({
  type: BranchDropdown.SET_BRANCH_DROPDOWN_LIST,
  payload,
});
